
import { required } from 'vuelidate/lib/validators'

export default {
  access: {
    tower_id: {
      required
    },
    unit_id: {
      required
    },
    visitor_id: {
      required
    },
    go_in: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/form/resources/validations.js